import { render, staticRenderFns } from "./BannerTitle.vue?vue&type=template&id=64b19ffc&"
import script from "./BannerTitle.vue?vue&type=script&lang=js&"
export * from "./BannerTitle.vue?vue&type=script&lang=js&"
import style0 from "./BannerTitle.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports